// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__Z1ozu","notes":"Notes_notes__2pN1m"};